import Vue from 'vue'
import VueTranslate from 'vue-translate-plugin'
Vue.use(VueTranslate)

// add translations directly to the application
Vue.locales({'en': require('./en.json')})
Vue.locales({'ru': require('./ru.json')})

// set the start locale to use
Vue.lang('ru')



// WEBPACK FOOTER //
// ./src/lang/index.js